<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form ref="Form" v-if="form">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :range-inline="false"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            default-option-text="Todos"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col 
                        class="flex-grow-1"
                        cols="3"
                    >
                        <rkm-form-select
                            :options="form.usuarios"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>



                    <rkm-col class="flex-grow-1">
                        <rkm-form-input-autocomplete
                            :repository="repositories.paciente"
                            :request-query-string-params="pacienteAutocompleteParams"
                            :search-fields="pacienteAutocompleteFields"
                            :text-field="(item) => item.cns ? `${this.formatCns(item.cns)} - ${item.nome}` : item.nome"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col
                        cols="auto"
                    >
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(getAtendimentos)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clear"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-table
            v-if="showList"
            :fields="fields"
            :items="items"
        >

            <template v-slot:cell(data)="row">
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(dataExportacao)="{ item }">
                {{ item.dataExportacao }} - {{ item.profissionalExportacao }}
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    @click.stop="search(item)"
                    color="primary"
                    title="Visualizar"
                    small
                >
                    <rkm-icon icon="search" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                    :disabled="item.exportado"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('atencaoBasica.procedimento'),
            paciente: this.getConectaSusRepository('atencaoBasica.procedimento').paciente,
        }

        this.load()
    },
    data: () => ({
        pacienteAutocompleteFields: [
            {key: 'cadastro_cidadao.nome', searchable: true},
            {key: 'cadastro_cidadao.nome_social', searchable: true},
            {key: 'cadastro_cidadao.cns', searchable: true},
            {key: 'cadastro_cidadao.cpf', searchable: true},
            {key: 'cadastro_cidadao.data_nascimento', searchable: true},
            {key: 'cadastro_paciente.prontuario', searchable: true},
        ],
        fields: [
            {
                key: 'data',
                label: 'Data',
                sortable: true
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true
            },
            {
                key: 'unidade',
                label: 'Unidade',
                sortable: true
            },
            {
                key: 'localAtendimento',
                label: 'Local de atendimento',
                sortable: true
            },
            {
                key: 'dataExportacao',
                label: 'Exportação',
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            paciente: null,
        },
        items: [],
        paciente: null,
        enums: {
            preferenciaNome
        },
        model: {
            unidadeId: null,
            infraestruturaId: null,
            periodo: {
                start: null,
                end: null
            },
            usuarioId: null,
            paciente: null,
        },
        form: null,
        defaultForm: null,
        showList: false
    }),
    computed: {
        pacienteAutocompleteParams() {

            return {
                periodo: {
                    start: this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                    end: this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                },
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                usuario_id: this.model.usuarioId,
            }
        },
    },
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.procedimento.index()
                .then(response => {
                    this.form = this.clone(response.data.form)
                    this.defaultForm = this.clone(response.data.form)
                    this.setDefaultValues()
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAtendimentos() {

            this.setLoading()

            this.repositories.procedimento.getAtendimentos(this.getSearchParams())
                .then(response => {
                    this.items = Object.assign(response.data.atendimentos)
                    this.showList = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.form.dataAtual, 'YYYY-MM-DD').toDate()
            this.model.periodo.end = moment(this.form.dataAtual, 'YYYY-MM-DD').toDate()
        },
        search(item) {

           this.$router.push({ name: 'atencao-basica-procedimento-edit', params: { id: item.id }})
        },
        clear(field) {

            if (field === 'periodo') {

                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.paciente = null
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.usuarios = []
            } else if (field === 'unidade') {

                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.paciente = null
                this.form.infraestruturas = []
                this.form.usuarios = []
            } else if (field === 'infraestrutura') {

                this.model.usuarioId = null
                this.model.paciente = null
                this.form.usuarios = []
            } else {

                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.paciente = null
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.usuarios = []

                this.setDefaultValues()
            }

            this.reset()
        },
        reset() {
            this.showList = false
            this.items = []
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.procedimento.destroy(id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir o atendimento?', destroy, this.handleError)
        },
        loadUnidades() {

            this.setLoading()

            this.repositories.procedimento.loadUnidades(this.getSearchParams())
                .then(({ data }) => {

                    this.form.unidades = data

                    if (data.length === 1) {
                        this.model.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadLocaisAtendimento() {

            this.setLoading()

            this.repositories.procedimento.loadLocaisAtendimento(this.getSearchParams())
                .then(({ data }) => {

                    this.form.infraestruturas = data

                    if (data.length === 1) {
                        this.model.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadProfissionais() {

            this.setLoading()

            this.repositories.procedimento.loadProfissionais(this.getSearchParams())
                .then(({ data }) => {

                    this.form.usuarios = data

                    if (data.length === 1) {
                        this.model.usuarioId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            params.pacienteId = params.paciente ? params.paciente.id : null
            delete params.paciente

            return this.camelObjectKeysToSnakeRecursive(params)
        },
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    props: {
        id: { type: Number, default: null }
    },
    watch: {
        'model.periodo.start'() {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.loadUnidades()
                this.clear('periodo')
            }
        },
        'model.periodo.end'() {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.loadUnidades()
                this.clear('periodo')
            }
        },
        'model.unidadeId'() {
            this.loadLocaisAtendimento()
            this.clear('unidade')
        },
        'model.infraestruturaId'() {
            this.loadProfissionais()
            this.clear('infraestrutura')
        },
        'model.usuarioId'() {
            this.reset()
        },
        'model.paciente'() {
            this.reset()
        },
    }
}
</script>

<style scoped>
p {
    margin: 0px;
}
</style>